//import { Link } from "gatsby"

import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTwitter } from "@fortawesome/free-brands-svg-icons"
import { faInstagram } from "@fortawesome/free-brands-svg-icons"

const Footer = ({ siteTitle }) => (
<footer class="footer">
  <container class="content has-text-centered">
  
    <p is-family-secondary>
      <strong>PublicArtSG</strong> Photographs are by Peter Schoppert, unless otherwise indicated. <br />The photos and all other website content
      is licensed <a href="http://creativecommons.org/licenses/by-nc-sa/4.0/">CC BY NC SA 4.0</a>. So please do attribute if you would like to use them.
    </p>
    <div className="buttons is-centered">
      <a className="button is-danger" href="https://www.instagram.com/publicartsg/">
      <span className="icon">
  <FontAwesomeIcon icon={faInstagram} />  
  </span>
  <span>@PublicArtSG</span>
      </a>
      <a className="button is-info" href="https://www.twitter.com/PublicArtSG">
  <span className="icon">
  <FontAwesomeIcon icon={faTwitter} />  
  </span>
  <span>@PublicArtSG</span>
</a>
      </div>
  </container>
</footer>
)
export default Footer
